import React from 'react';
import PropTypes from 'prop-types';
import SocialIcons from '@components/SocialIcons';
import FlapBoard from '@components/FlapBoard';
import Footer from '@components/Footer';
import './style.scss';

const CONTACT_ROW = [
  {
    text:   'CONTACT',
    colors: ['pink','pink','pink','pink','pink','pink','pink'],
  },
];

const ContactPage = (props, context) => {
  const { theme: { colorPrimary, textPrimary } } = context;

  return (
    <div id="contact" className="contact-page">
      <div className="content-grid">
        <FlapBoard heading="h2" autoPlay={false} rows={CONTACT_ROW} />
        <div className="contact-wrapper" style={{ color: textPrimary }}>
          <p className="contact-tagline reveal" style={{ '--reveal-delay': '0s' }}>Let's build something together.</p>
          <a
            className="contact-email reveal"
            href="mailto:dnguyen13412@gmail.com"
            style={{ color: colorPrimary, borderColor: colorPrimary, '--reveal-delay': '0.15s' }}
          >
            dnguyen13412@gmail.com
          </a>
          <div className="reveal" style={{ '--reveal-delay': '0.3s' }}>
            <SocialIcons />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

ContactPage.contextTypes = {
  theme: PropTypes.any
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/ContactPage/ContactPage.js